import React, { useEffect, useState } from 'react';
import "./header.css";
// Import both images from your assets folder
import desktopBanner from '../../assets/wepb_images/slider-4.webp';
import mobileBanner from '../../assets/wepb_images/slidermobile.webp'; // Tailored crop for mobile view
import Popupbox from '../popupbox/Popupbox';
import yellowbg from "../../assets/yellow-bg.png";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Popupboxbox from '../popupbox/Popupbox';


function Header() {
  const [showModal, setShowModal] = useState(false);


  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);
  return (
    <>
      <div className="hero-container">
        {/* Background Image Container with Dynamic Inline CSS Variables */}
        <div
          className="hero-bg"
          style={{
            '--desktop-bg': `url(${desktopBanner})`,
            '--mobile-bg': `url(${mobileBanner})`
          }}
        />

        {/* Dark overlay to make text highly readable */}
        <div className="hero-overlay" />

        {/* Main Content Area */}
        <div className="hero-content">
          <div className="content-block">

            {/* Main Catchy Heading */}
            <h1
              className="hero-title title-webview"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              Learn from Experts & Earn <br />
              <span className="highlight-wrapper">like experts</span>
              {" "} (3-6 LPA as a Fresher)

              <img
                src={yellowbg}
                alt="brush stroke"
                className="title-line1"
              />
            </h1>

            <h1
              className="hero-title title-mobileview"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              Learn from Experts & Earn &nbsp;
              <span className="highlight-wrapper">like experts</span>
              <br />
              (3-6 LPA as a Fresher)

              <img
                src={yellowbg}
                alt="brush stroke"
                className="title-line1"
              />
            </h1>

            {/* Key Features Bullet List */}
            <ul className="feature-list"
            >
              <li className="feature-item" data-aos="fade-up"
                data-aos-delay="200">
                <span className="bullet-square">▪</span>
                <span>One on One training</span>
              </li>
              <li className="feature-item" data-aos="fade-up"
                data-aos-delay="200">
                <span className="bullet-square">▪</span>
                <span>Online & Offline classes</span>
              </li>
              <li className="feature-item" data-aos="fade-up"
                data-aos-delay="200">
                <span className="bullet-square">▪</span>
                <span>100% Assured Placement Assistance</span>
              </li>
              <li className="feature-item" data-aos="fade-up"
                data-aos-delay="200">
                <span className="bullet-square">▪</span>
                <span>Learn from Live Projects</span>
              </li>
              <li
                className="feature-item"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <span className="bullet-square">▪</span>
                <span>ISO Certified Training Academy</span>
              </li>
            </ul>

            {/* Outline Action Button */}
            <button className="enroll-btn" onClick={() => setShowModal(true)}
              data-aos="fade-up"
              data-aos-delay="300"
            >
              Enroll Now
            </button>

          </div>
        </div>
      </div>
      <Popupboxbox isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}

export default Header;